import {Spin} from "antd";
import {LoadingOutlined} from "@ant-design/icons";
import ContainerComponent from "../../../helpers/components/container.component";
import PageHeaderComponent from "../../../helpers/components/page_header.component";
import globalHelper from "../../../helpers/functions/global.helper";
import React, {useState} from "react";

const PaymentDetail = (props) => {
    const [showModal, setShowModal] = useState(false);
    const {activity} = props;
    const [state, setState] = useState({
        loading: false,
    });

    const faceUrl = activity?.payment?.face_url;

    return (
        <>
            <Spin spinning={state?.loading} indicator={<LoadingOutlined/>}>
                <div style={{textAlign: 'start', marginBottom: 20,}}>
                    <div className='title-header mobile-padding-24'>
                        <ContainerComponent span={20}>
                            <PageHeaderComponent title={'Activity Details - Payment'} textAlign={'start'}/>
                        </ContainerComponent>
                    </div>
                    <div
                        className='mobile-padding-24'
                        {...!globalHelper?.isMobileScreen() && ({style: {marginTop: 24,}})}
                    >
                        <ContainerComponent span={20}>
                            <div style={{ padding: '24px' }}>
                                <h2 style={{ marginBottom: '20px' }}>Activity Details</h2>

                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: '200px 1fr',
                                    rowGap: '12px',
                                    columnGap: '16px'
                                }}>
                                    <div><strong>Transaction No:</strong></div>
                                    <div>{activity?.transaction_no || '-'}</div>

                                    <div><strong>Transaction Type:</strong></div>
                                    <div>{activity?.transaction_type?.name || '-'}</div>

                                    <div><strong>Customer Name:</strong></div>
                                    <div>{activity?.from_wallet?.customer?.name || '-'}</div>

                                    <div><strong>Phone Number:</strong></div>
                                    <div>
                                        {activity?.from_wallet?.customer
                                            ? `${activity.from_wallet.customer.mobile_dial_no || ''}${activity.from_wallet.customer.phone_no || ''}`
                                            : '-'}
                                    </div>

                                    <div><strong>Customer Wallet ID:</strong></div>
                                    <div>{activity?.from_wallet?.name ?? '-'}</div>

                                    <div><strong>Merchant Name:</strong></div>
                                    <div>{activity?.to_wallet?.merchant?.name || '-'}</div>


                                    <div><strong>Merchant Wallet ID:</strong></div>
                                    <div>{activity?.to_wallet?.name || '-'}</div>

                                    <div><strong>Payment At:</strong></div>
                                    <div>{activity?.payment ? new Date(activity.payment.created_at).toLocaleString() : '-'}</div>

                                    <div><strong>Melon Amount:</strong></div>
                                    <div>{activity?.melon_amount ?? '-'}</div>

                                    <div><strong>Face Photo:</strong></div>
                                    <div>
                                        {faceUrl ? (
                                            <>
                                                <img
                                                    src={faceUrl}
                                                    alt="Face"
                                                    style={{maxWidth: '200px', borderRadius: '8px', cursor: 'pointer'}}
                                                    onClick={() => setShowModal(true)}
                                                />

                                                {showModal && (
                                                    <div
                                                        onClick={() => setShowModal(false)}
                                                        style={{
                                                            position: 'fixed',
                                                            top: 0,
                                                            left: 0,
                                                            width: '100vw',
                                                            height: '100vh',
                                                            backgroundColor: 'rgba(0,0,0,0.7)',
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                            zIndex: 1000,
                                                        }}
                                                    >
                                                        <img
                                                            src={faceUrl}
                                                            alt="Face Full"
                                                            style={{
                                                                maxWidth: '90vw',
                                                                maxHeight: '90vh',
                                                                borderRadius: '8px',
                                                                boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
                                                            }}
                                                        />
                                                    </div>
                                                )}
                                            </>
                                        ) : (
                                            '-'
                                        )}
                                    </div>

                                    {/* Add more fields as needed */}
                                </div>
                            </div>
                        </ContainerComponent>

                    </div>
                </div>
            </Spin>
        </>
    );
};

export default PaymentDetail;